import { highlightChars } from '../HighlightExercise';

export const stripHighlightChars = (str: string) =>
    str.replace(new RegExp(`[${highlightChars.join('')}]`, 'g'), '');
